import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getInitialLocale } from "../i18n/routing";
import { useTranslation } from 'react-i18next';
// import { useLocalePath } from '../i18n/hooks';

function LandingPage() {
  const { t } = useTranslation('common');
  // const localePath = useLocalePath();
  const homePath = `/${getInitialLocale()}/home`;

  // Define the array of phrases you want to cycle through
  const phrases = [
    t('landing.tagline'),
    t('landing.taglines.0'),
    t('landing.taglines.1'),
    t('landing.taglines.2')
    // t('landing.taglines.3')
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [animationClass, setAnimationClass] = useState("pixel-fade-in");

  useEffect(() => {
    const cycleInterval = setInterval(() => {
      // 1. Trigger the "phase out" animation
      setAnimationClass("pixel-fade-out");

      // 2. Wait for the fade-out to finish, change text, and trigger "phase in"
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % phrases.length);
        setAnimationClass("pixel-fade-in");
      }, 600); // 600ms matches our CSS animation duration

    }, 2000); // Switch phrase every 2 seconds

    return () => clearInterval(cycleInterval);
  }, [phrases.length]);

  return (
    <div className="min-vh-100 bg-white d-flex align-items-center">
      <Container className="d-flex flex-column justify-content-center align-items-center text-center">
        <div className="aspect-ratio-container">
          <img
            src="/See3eye_logoonly_round.png"
            alt="bringing ideas to life"
            className="App-logo img-fluid"
            style={{ maxWidth: '500px', width: '75%', height: 'auto' }}  // Scales with screen, capped at 500px
          />
        </div>
        {/* <div className="aspect-ratio-container">
          <img
            src="/see3eye_text.png"
            alt="bringing ideas to life"
            className="App-logo img-fluid"
            style={{ maxWidth: '500px', width: '100%', height: 'auto' }}  // Scales with screen, capped at 500px
          />
        </div> */}

        {/* Staff Augmentation */}
        <h6 className="landing-title fw-bold text-muted mb-0 w-50">
          {/* small business holding company */}
        </h6>

        {/* Animated text element */}
        {/* <h5 className={`landing-tagline fw-bold text-muted mb-2 w-50 ${animationClass}`}>
          {phrases[currentIndex]}
        </h5> */}

        <div className="d-flex gap-2">
        <a
            href="https://www.linkedin.com/company/see3eye"
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary text-white btn-sm mt-1 mb-5"
          >
            {t('landing.ctaContactViaLinkedIn')}
          </a>
            
            {/* <Link to={localePath('/contact')} className="btn btn-primary btn-sm mt-1 mb-5">
              {t('landing.ctaContactViaLinkedIn')}
            </Link> */}
          {/* <Link to={homePath} className="btn btn-primary text-white btn-sm mt-1 mb-5">
            {t('landing.ctaReadMore')}
          </Link> */}
        </div>
      </Container>
    </div>
  );
}

export default LandingPage;
